// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sunzi__edit-wrapper-KD3fA {
  z-index: 11;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE {
  position: relative;
  width: 100%;
  height: 100%;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-header-hEMH1 {
  position: absolute;
  top: 0;
  transition: top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  background: #fff;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-header-hEMH1.sunzi__edit-header-hide-hOorm {
  top: -60px;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-header-content-XGMU2 {
  font-size: 16px;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-header-submit-wpdKS {
  font-weight: 700;
  color: white;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-content-_jmKQ {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url('https://assets.sunzi.cool/new-mini-me/curtain.png');
  padding: 60px 0 70px;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-content-_jmKQ canvas {
  width: 100%;
  height: 100%;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE .sunzi__erasure-wrapper-C2PTg {
  height: calc(100% - 130px);
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE .sunzi__erasure-button-group-JU3Qm {
  position: absolute;
  bottom: 90px;
  padding: 0 15px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE .sunzi__erasure-button-group-JU3Qm.sunzi__erasure-button-group-down-dXg7h {
  bottom: 25px;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE .sunzi__erasure-button-group-JU3Qm.sunzi__erasure-button-group-hide-sJZ3X {
  bottom: auto;
  bottom: initial;
  z-index: 2;
  top: -72px;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE .sunzi__erasure-button-group-JU3Qm.sunzi__erasure-button-group-show-wu7FR {
  top: 20px;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE .sunzi__erasure-button-group-JU3Qm #sunzi__button-GsoUr {
  height: 52px;
  width: 52px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06), 0px 4px 12px rgba(0, 0, 0, 0.12);
  cursor: pointer;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE .sunzi__erasure-button-group-JU3Qm .sunzi__button-group-t7ZN1 {
  display: flex;
  align-items: center;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE .sunzi__erasure-button-group-JU3Qm .sunzi__erasure-button-mamQK {
  height: 52px;
  width: 52px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06), 0px 4px 12px rgba(0, 0, 0, 0.12);
  cursor: pointer;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE .sunzi__erasure-button-group-JU3Qm .sunzi__erasure-close-sip36 {
  height: 52px;
  width: 52px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06), 0px 4px 12px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  background-color: #fff;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE .sunzi__erasure-button-group-JU3Qm .sunzi__erasure-revoke-VvrEj {
  height: 52px;
  width: 52px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06), 0px 4px 12px rgba(0, 0, 0, 0.12);
  cursor: pointer;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE .sunzi__erasure-button-group-JU3Qm .sunzi__erasure-confirm-t3mD_ {
  height: 52px;
  width: 52px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06), 0px 4px 12px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  background-color: #000;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE .sunzi__footer-AGYVY {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 84px;
  display: flex;
  justify-content: space-evenly;
  background-color: #fff;
  transition: bottom 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE .sunzi__footer-AGYVY.sunzi__footer-hide-foZVz {
  bottom: -84px;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE .sunzi__footer-AGYVY .sunzi__button-GsoUr {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.sunzi__edit-wrapper-KD3fA .sunzi__edit-j5QjE .sunzi__footer-AGYVY .sunzi__button-GsoUr span {
  font-size: 16px;
  line-height: 24px;
  min-width: 60px;
  text-align: center;
  color: black;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Edit/style.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAFA;EAII,kBAAA;EACA,WAAA;EACA,YAAA;AACJ;AACI;EACE,kBAAA;EACA,MAAA;EACA,yDAAA;EACA,gBAAA;AACN;AACM;EACE,UAAA;AACR;AAEM;EACE,eAAA;AAAR;AAGM;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AADR;AAKI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0EAAA;EACA,oBAAA;AAHN;AAFI;EAQI,WAAA;EACA,YAAA;AAHR;AArCA;EA6CM,0BAAA;AALN;AAxCA;EAiDM,kBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,yDAAA;AANN;AAQM;EACE,YAAA;AANR;AAQM;EACE,YAAA;EAAA,eAAA;EACA,UAAA;EACA,UAAA;AANR;AAQM;EACE,SAAA;AANR;AA5DA;EAsEQ,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,6EAAA;EAEA,eAAA;AARR;AAvEA;EAmFQ,aAAA;EACA,mBAAA;AATR;AA3EA;EAsEQ,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,6EAAA;EAEA,eAAA;AAOR;AAtFA;EAsEQ,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,6EAAA;EAEA,eAAA;EAcA,sBAAA;AAIR;AAjGA;EAsEQ,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,6EAAA;EAEA,eAAA;AA6BR;AA5GA;EAsEQ,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,6EAAA;EAEA,eAAA;EAuBA,sBAAA;AAkBR;AAxHA;EA2GM,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,sBAAA;EACA,4DAAA;AAgBN;AAdM;EACE,aAAA;AAgBR;AArIA;EAyHQ,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAeR;AA7IA;EAiIU,eAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AAeV","sourcesContent":[".edit-wrapper {\n  z-index: 11;\n\n  .edit {\n    position: relative;\n    width: 100%;\n    height: 100%;\n\n    &-header {\n      position: absolute;\n      top: 0;\n      transition: top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n      background: #fff;\n\n      &.edit-header-hide {\n        top: -60px;\n      }\n\n      &-content {\n        font-size: 16px;\n      }\n\n      &-submit {\n        font-weight: 700;\n        color: white;\n        text-align: center;\n        text-transform: uppercase;\n        cursor: pointer;\n      }\n    }\n\n    &-content {\n      position: relative;\n      width: 100%;\n      height: 100%;\n      background-image: url('https://assets.sunzi.cool/new-mini-me/curtain.png');\n      padding: 60px 0 70px;\n\n      canvas {\n        width: 100%;\n        height: 100%;\n      }\n    }\n\n    .erasure-wrapper {\n      height: calc(100% - 130px);\n    }\n\n    .erasure-button-group {\n      position: absolute;\n      bottom: 90px;\n      padding: 0 15px;\n      width: 100%;\n      display: flex;\n      justify-content: space-between;\n      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n\n      &.erasure-button-group-down {\n        bottom: 25px;\n      }\n      &.erasure-button-group-hide {\n        bottom: unset;\n        z-index: 2;\n        top: -72px;\n      }\n      &.erasure-button-group-show {\n        top: 20px;\n      }\n\n      #button {\n        height: 52px;\n        width: 52px;\n        border-radius: 50px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-color: #fff;\n        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06),\n          0px 4px 12px rgba(0, 0, 0, 0.12);\n        cursor: pointer;\n      }\n\n      .button-group {\n        display: flex;\n        align-items: center;\n      }\n\n      .erasure-button {\n        #button();\n      }\n\n      .erasure-close {\n        #button();\n        background-color: #fff;\n      }\n\n      .erasure-revoke {\n        #button();\n      }\n\n      .erasure-confirm {\n        #button();\n        background-color: #000;\n      }\n    }\n\n    .footer {\n      position: absolute;\n      bottom: 0;\n      width: 100%;\n      height: 84px;\n      display: flex;\n      justify-content: space-evenly;\n      background-color: #fff;\n      transition: bottom 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n\n      &.footer-hide {\n        bottom: -84px;\n      }\n\n      .button {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n\n        span {\n          font-size: 16px;\n          line-height: 24px;\n          min-width: 60px;\n          text-align: center;\n          color: black;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"edit-wrapper": `sunzi__edit-wrapper-KD3fA`,
	"editWrapper": `sunzi__edit-wrapper-KD3fA`,
	"edit": `sunzi__edit-j5QjE`,
	"edit-header": `sunzi__edit-header-hEMH1`,
	"editHeader": `sunzi__edit-header-hEMH1`,
	"edit-header-hide": `sunzi__edit-header-hide-hOorm`,
	"editHeaderHide": `sunzi__edit-header-hide-hOorm`,
	"edit-header-content": `sunzi__edit-header-content-XGMU2`,
	"editHeaderContent": `sunzi__edit-header-content-XGMU2`,
	"edit-header-submit": `sunzi__edit-header-submit-wpdKS`,
	"editHeaderSubmit": `sunzi__edit-header-submit-wpdKS`,
	"edit-content": `sunzi__edit-content-_jmKQ`,
	"editContent": `sunzi__edit-content-_jmKQ`,
	"erasure-wrapper": `sunzi__erasure-wrapper-C2PTg`,
	"erasureWrapper": `sunzi__erasure-wrapper-C2PTg`,
	"erasure-button-group": `sunzi__erasure-button-group-JU3Qm`,
	"erasureButtonGroup": `sunzi__erasure-button-group-JU3Qm`,
	"erasure-button-group-down": `sunzi__erasure-button-group-down-dXg7h`,
	"erasureButtonGroupDown": `sunzi__erasure-button-group-down-dXg7h`,
	"erasure-button-group-hide": `sunzi__erasure-button-group-hide-sJZ3X`,
	"erasureButtonGroupHide": `sunzi__erasure-button-group-hide-sJZ3X`,
	"erasure-button-group-show": `sunzi__erasure-button-group-show-wu7FR`,
	"erasureButtonGroupShow": `sunzi__erasure-button-group-show-wu7FR`,
	"button": `sunzi__button-GsoUr`,
	"button-group": `sunzi__button-group-t7ZN1`,
	"buttonGroup": `sunzi__button-group-t7ZN1`,
	"erasure-button": `sunzi__erasure-button-mamQK`,
	"erasureButton": `sunzi__erasure-button-mamQK`,
	"erasure-close": `sunzi__erasure-close-sip36`,
	"erasureClose": `sunzi__erasure-close-sip36`,
	"erasure-revoke": `sunzi__erasure-revoke-VvrEj`,
	"erasureRevoke": `sunzi__erasure-revoke-VvrEj`,
	"erasure-confirm": `sunzi__erasure-confirm-t3mD_`,
	"erasureConfirm": `sunzi__erasure-confirm-t3mD_`,
	"footer": `sunzi__footer-AGYVY`,
	"footer-hide": `sunzi__footer-hide-foZVz`,
	"footerHide": `sunzi__footer-hide-foZVz`
};
export default ___CSS_LOADER_EXPORT___;
